






















































































































import { Component, Vue } from "vue-property-decorator";
import { State, Action } from "vuex-class";
import _ from "lodash";
// import { firstDayInPrevMonth, formatDateTime } from "@/global.ts";
import GlobalMixins from "@/global.mixin";

@Component({
  mixins: [GlobalMixins],
  components: {  }
})
export default class ProductView extends Vue {
  @State("products") productsState: any;
  @Action("getProducts") getProducts: any;
  @Action("saveProduct") saveProduct: any;
  @Action("deleteProduct") deleteProduct: any;

  @State("locations") locationsState: any;
  @Action("getLocations") getLocations: any;

  snackbar = false;
  snacktext = "";
  loader = false;
  search = "";

  locationsSearchTerm = "";
  containerTypes = [];
  locationsSearched: string[] = [];

  editingDialog = false;
  editedIndex = -1;
  isNewItem = false;

  defaultItem = {
    productId: 0,
    rfidCode: "",
    barCode: "",
    locationId: -1,
    storageType: "",
    description: "",
    deleted: false,
  };
  editedItem = Object.assign({}, this.defaultItem);

  rowsPerPageItems = [10, 25, 50, 100, 200, { text: "All", value: -1 }];

  pagination = {
    sortBy: "rfidCode",
    descending: false,
    page: 1,
    rowsPerPage: this.$cookies.isKey("products-rowsPerPage") ?
                        parseInt(this.$cookies.get("products-rowsPerPage"), 10) : 25
  };
  totalItem = 2;


  ecoDropdown = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  serversideSearch = _.debounce(() => {
    this.updatePagination(this.pagination);
  }, 300);

  getHeaders() { return [
      { text: "#", value: "productId", width: "1%", align: "left"},
      { text: this.$t("ITEMS_TABLE_PRODUCT_CODE"), value: "barCode", width: "1%", align: "left" },
      { text: this.$t("ITEMS_TABLE_PRODUCT_NAME"), value: "description", width: "1%", align: "left" },
      { text: this.$t("ITEMS_TABLE_PRODUCT_STORAGE_TYPE"), value: "storageType", width: "1%", align: "left"},
      { text: this.$t("ITEMS_TABLE_PRODUCT_LOCATION"), value: "location.name", width: "1%", align: "left"},
      { text: "", value: "name", width: "1%", sortable: false, },
      { text: this.$t("TABLE_ACTIONS"), value: "name", sortable: false, }
    ];
  }

  created() {
    this.getLocations();
    this.searchContainerTypes(null);
  }

  reload() {
    this.updatePagination(this.pagination);
  }

  changeSort(column) {
    if (this.pagination.sortBy === column) {
      this.pagination.descending = !this.pagination.descending;
    } else {
      this.pagination.sortBy = column;
      this.pagination.descending = false;
    }
    this.updatePagination(this.pagination);
  }

  // lapozáskor hívódik meg, ill. ha item/oldalszámot választunk
  updatePagination(pagination) {

    this.$cookies.set("products-rowsPerPage", pagination.rowsPerPage);

    const searchexpression = this.search.trim();
    const x = searchexpression.split(" ");
    const page = {
      sortBy: pagination.sortBy,
      descending: pagination.descending,
      page: pagination.page,
      rowsPerPage: pagination.rowsPerPage,
      searchString: x,
    };
    this.getProducts(page);
  }

  searchContainerTypes(e) {
    if (!this.locationsSearchTerm) {
      this.locationsSearched = this.locationsState.locations;
      return;
    }

    this.locationsSearched = this.locationsState.locations.filter((item) => {
      return item.name.indexOf(this.locationsSearchTerm.toUpperCase()) > -1;
    });
  }


  save() {

    this.editedItem.rfidCode = this.editedItem.barCode;

    this.saveProduct({
      data: JSON.stringify(this.editedItem),
      index: this.editedIndex
    })
      .then(res => {
        this.close();
      })
      .catch(res => {
        // handle....
        // this.close();
      });
  }

  close() {
    this.editingDialog = false;
    this.editedItem = Object.assign({}, this.defaultItem);
    this.editedIndex = -1;
  }
  editItem(item) {
    this.isNewItem = false;
    this.editedIndex = this.productsState.products.indexOf(item);
    this.editedItem = Object.assign({}, item);

    this.editingDialog = true;
  }
  deleteItem(item) {
    const index = this.productsState.products.indexOf(item);

    if (confirm("Are you sure to delete the Item?")) {
      this.deleteProduct({ id: item.productId, index });
    }
  }
}
